<template>
    <div class="dismounted-bg">
        <div class="dismounted-head">
            <!-- <div class="dismounted-title"><label>安医绩溪院区整件区</label></div> -->
            <div class="dismounted-title"><label>{{orgName}}整件区</label></div>
            <h3 class="date">{{ date }}</h3>
        </div>
        <div class="dismounted-content">
            <div class="layout layout-left-top">
                <div class="dismounted-panel border-all">
                    <div class="panel-title"><label>库存品规</label></div>
                    <div class="chart" dg-chart-widget="" id="material_type">
                    </div>
                    <div class="border-foot"></div>
                </div>
            </div>
            <!--<div class="layout layout-left-center">
                <div class="dismounted-panel border-all">
                    <div class="panel-title"><label>标题1</label></div>
                    <div class="chart" dg-chart-widget=""></div>
                    <div class="border-foot"></div>
                </div>
            </div>-->
            <div class="layout layout-left-bottom">
                <div class="dismounted-panel border-all">
                    <div class="panel-title"><label>每日入库量</label></div>
                    <div class="chart" dg-chart-widget="" id="in_line" >
                    </div>
                    <div class="border-foot"></div>
                </div>
            </div>
            <div class="layout layout-center-top">
                <div class="dismounted-panel border-all">
                    <div class="panel-total1">
                        <div>{{data.materialAmount}}</div>
                        &nbsp;
                        <div>品规总数</div>
                    </div>
                    <div class="panel-total2">
                        <span>{{data.materialPrice}}</span>
                        &nbsp;
                        <span>品规总金额</span>
                    </div>
                </div>
            </div>
            <div class="layout layout-center-bottom">
                <div class="dismounted-panel border-all">
                    <div class="panel-title"><label>近效期物资列表</label></div>
                    <div dg-chart-widget="">
                        <DismountedSeamless :listData="listData"/>
                    </div>
                    <div class="border-foot"></div>
                </div>
            </div>
            <div class="layout layout-right-top">
                <div class="dismounted-panel border-all">
                    <div class="panel-title"><label>品规金额</label></div>
                    <div class="chart" dg-chart-widget="" id="material_type_price"></div>
                    <div class="border-foot"></div>
                </div>
            </div>
            
            <div class="layout layout-right-bottom">
                <div class="dismounted-panel border-all">
                    <div class="panel-title"><label>每日拆包量</label></div>
                    <div class="chart" dg-chart-widget="" id="out_line"></div>
                    <div class="border-foot"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue } from "vue-property-decorator";
import moment from "moment";
import { BaseModule } from "@/store/modules/base/base";
import {pieChart,lineSmooth, barData} from "@/util/util";
import DismountedSeamless from "./components/DismountedSeamless.vue";

export default {
    // 待验收区单面屏
    name: 'pieChart',
    components: {
        DismountedSeamless,
    },
    data () {
        return {
            timer: null,
            date: null,
            // orgId: this.$route.query.orgId,
            orgName: this.$route.query.orgName,

            data:{
            },
            listData:[],
            in_line: {},
            out_line: {},
        }
    },
    mounted () {
        this.queryData();
        const that = this;
        this.timer = setInterval(() => {
            that.date = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
        }, 1000);
    },
    methods: {
        init(){
            const material_type = this.$echarts.init(document.getElementById("material_type"), "light");

            pieChart(material_type, {
                data:this.data.expiringMaterialList,color:['#80ffbf', '#ccffe6','#6e7074', '#546570', '#c4ccd3'],name:"品规", unit:"个"}
            );

            const material_type_price = this.$echarts.init(document.getElementById("material_type_price"), "light");
            pieChart(material_type_price, {
                data:this.data.expiringMaterialPriceList,color:['#80ffbf', '#ccffe6', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3'], name:"品规金额", unit:"元"}
            );

            this.in_line = this.$echarts.init(document.getElementById("in_line"));
            lineSmooth(this.in_line, this.data.everyDayInDataVO);
            console.log(this.in_line, "in_line")

            this.out_line = this.$echarts.init(document.getElementById("out_line"));
            barData(this.out_line, this.data.everyDayOutDataVO);
            this.listData = this.data.expiringList
            console.log(this.out_line, "out_line")
        },
        queryData(){
            BaseModule.getWholePieceData({
            orgId: this.$route.query.orgId,
            auth: false
            })
            .then(res => {
                if (res.code === 200) {
                    this.data = res.data;
                    this.init();
                } else {
                    this.$message.error(res.message);
                }
            })
            .catch(err => {
                console.log(err, "err");
            });
        }
    },
    beforeDestroy () {
        if (this.timer) {
            clearInterval(this.timer);
        }
        clearInterval(this.in_line.startCharts)
        clearInterval(this.out_line.startCharts)
    }
}
</script>


<style lang="scss" scoped>
.dismounted-bg {
    width: 100vw;
    height: 100vh;
    color: #FFF;
    // background: url(../../assets/image/bg.png);
    background: #071940;
    margin: 0 0;
    padding: 0 0;
    position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
}
.chart:empty{
	border: 1px dashed;
	box-sizing: border-box;
	-moz-box-sizing: border-box;
	-webkit-box-sizing: border-box;
	opacity: 0.3;
}
.chart:empty::after{
	content: "图表";
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -1rem;
	margin-left: -1rem;
}

.fill-parent{
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
}
.dismounted-head{
    height: 4rem;
    background-image: url(~@/assets/image/head_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.dismounted-head .dismounted-title{
	font-size: 2rem;
	text-align: center;
	padding-top: 0.5em;
}
.dismounted-content{
	position: absolute;
	top: 4.5rem;
	right: 0;
	bottom: 0;
	left: 0;
}
.layout{
	position: absolute;
	width: 33.33%;
}
.layout-left-top{
	left: 0;
	top: 0;
	height: 45%;
}
.layout-left-center{
	left: 0;
	top: 33.33%;
	height: 33.33%;
}
.layout-left-bottom{
	left: 0;
	top: 45%;
	height: 55%;
}
.layout-center-top{
	top: 0;
	left: 33.33%;
	right: 66.6%;
	height: 25%;
    font-size: 1rem;
}
.layout-center-bottom{
	top: 25%;
	left:33.33%;
	right: 66.6%;
	bottom: 0;
}
.layout-right-top{
	top: 0;
	right: 0;
	height: 45%;
}
.layout-right-center{
	top: 33.3%;
	right: 0;
	height: 33.3%;
}
.layout-right-bottom{
	top: 45%;
	right: 0;
	bottom: 0;
}
.dismounted-panel{
	position: absolute;
    left: 0.4rem;
    top: 0.4rem;
    right: 0.4rem;
    bottom: 0.4em;
    border-radius: 10px;
    border: 1px #0174f5 solid;
    box-shadow: 0px 0px 6px #0174f5;
    box-sizing: border-box;
    font-size: 20px;
}
.dismounted-panel.border-left-top:before,
.dismounted-panel.border-all:before{
	/*
	position: absolute;
    width: 1rem;
    height: 1rem;
    content: "";
    border-top: 6px solid #4788fb;
    border-left: 6px solid #4788fb;
    left: -3px;
    top: -3px;
    */
}
.dismounted-panel.border-right-top:after,
.dismounted-panel.border-all:after{
	/*
	position: absolute;
    width: 1rem;
    height: 1rem;
    content: "";
    border-top: 6px solid #4788fb;
    border-right: 6px solid #4788fb;
    right: -3px;
    top: -3px;
    */
}
.dismounted-panel.border-left-bottom .border-foot:before,
.dismounted-panel.border-all .border-foot:before{
	/*
	position: absolute;
    width: 1rem;
    height: 1rem;
    content: "";
    border-bottom: 6px solid #4788fb;
    border-left: 6px solid #4788fb;
    left: -3px;
    bottom: -3px;
    */
}
.dismounted-panel.border-right-bottom .border-foot:after,
.dismounted-panel.border-all .border-foot:after{
	/*
	position: absolute;
    width: 1rem;
    height: 1rem;
    content: "";
    border-bottom: 6px solid #4788fb;
    border-right: 6px solid #4788fb;
    right: -3px;
    bottom: -3px;
    */
}
.dismounted-panel > .panel-title{
	position: absolute;
	top: 0.2rem;
	right: 20%;
	left: 20%;
	line-height: 1.2rem;
	font-size: 1rem;
    text-align: center;
    color: #fff;
    font-size: 18px;
}
.dismounted-panel .chart{
	position: absolute;
	top: 1.4rem;
	right: 0.3rem;
	bottom: 0.3rem;
	left: 0.3rem;
}

.dismounted-panel .panel-total1 {
    position: absolute;
	height: 98%;
    width: 47%;
    border-right: #0174f5 1px solid;
    border-bottom: #0174f5 1px solid;
    //background: linear-gradient(90deg,#1890ff,#1b7ef7,#6eafff);
    border-radius: 5px;
    display: flex; 
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.dismounted-panel .panel-total2 {
    position: absolute;
	left: 52.5%;
	height: 98%;
    width: 47%;
    border-left: #0174f5 1px solid;
    border-bottom: #0174f5 1px solid;
    border-radius: 5px;
    display: flex; 
    justify-content: center;
    align-items: center;
    flex-direction: column;
    //background: linear-gradient(90deg,#1890ff,#1b7ef7,#6eafff);
}

.dismounted-panel .panel-total3 {
    position: absolute;
	top: 52%;
	height: 45%;
    width: 47%;
    border-radius: 5px;
    border-top: #0174f5 1px solid;
    border-right: #0174f5 1px solid;
    display: flex; 
    justify-content: center;
    align-items: center;
    flex-direction: column;
    //  background: linear-gradient(70deg,#11b981,#36e8c0);
    //background: linear-gradient(70deg, #8080ff,#9999ff,#ccccff);
    //background: linear-gradient(90deg,#4d94ff,#1b7ef7,#6eafff);
}

.dismounted-panel .panel-total4 {
    position: absolute;
	top: 52.5%;
    left: 52.5%;
	height: 45%;
    width: 47%;
    border-radius: 5px;
    border-top: #0174f5 1px solid;
    border-left: #0174f5 1px solid;
    display: flex; 
    justify-content: center;
    align-items: center;
    flex-direction: column;
    //background: linear-gradient(70deg, #8080ff,#9999ff,#ccccff);
    //background: linear-gradient(90deg,#33d6ff,#4ddbff,#80e5ff);
}
.date {
    font-size: 24px;
    display: flex;
    justify-content: space-around;
    color: #fff;
    padding-left: 10px;
    position: absolute;
    right: 3%;
    top: 2%;
}
</style>